import React from "react";
import Button from "components/CustomButtons/Button.js";
import { Visibility, LocalActivity } from "@material-ui/icons";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
export default function ActionNormal({ item }) {
  return (
    <>
      {item ? (
        <div className="actions-right">
          <Link to={"/admin/pup404/view/" + item._id}>
            <Button justIcon round simple color="success" className="edit">
              <Visibility />
            </Button>
          </Link>
          <Link to={"/admin/pup404/activity/" + item._id}>
            <Button justIcon round simple color="success" className="edit">
              <LocalActivity />
            </Button>
          </Link>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
}

ActionNormal.propTypes = {
  item: PropTypes.any,
  onCallNetwork: PropTypes.func,
  refresh: PropTypes.func,
};
